import { createSelector } from 'reselect'
import getItemsCartSelect from 'modules/cart/redux/selectors/get-items'
import isFreeBonusDeluxeSampleCartUtil from 'modules/cart/utils/is-free-bonus-deluxe-sample'

const getFreeBonusDeluxeSamplesCountCartSelect = createSelector(
  getItemsCartSelect,
  (cartItems) => {
    return cartItems.reduce((count, item) => {
      if (isFreeBonusDeluxeSampleCartUtil(item)) {
        return count + 1
      }
      return count
    }, 0)
  }
)

export default getFreeBonusDeluxeSamplesCountCartSelect
